<template>
  <v-container
    id="enrollerTab"
    class="pa-0"
  >
    <base-resource-grid
      ref="resourceGrid"
      color="green"
      icon="mdi-format-list-text"
      plural-name="Enroller"
      singular-name="Enroller"
      allow-expand
      :headers="gridHeaders"
      :resource="enrollerResource"
      :fetch-method="getEnroller"
      :actions="actions"
      :prepare-save="prepareSave"
      :disabled="disabled"
      @handleAction="handleAction"
      @item:updated="itemChanged"
      @item:added="itemChanged"
      @item:deleted="itemChanged"
    >
      <template
        v-slot:editForm="bindings"
        class="pa-0"
      >
        <enroller-edit
          v-model="bindings.editedItem"
          class="pa-0"
          :open-enrollment="openEnrollment"
          :form-errors="bindings.formErrors"
          :disabled="disabled"
        />
      </template>
    </base-resource-grid>
    <base-history-dialog
      resource-endpoint="oeEnrollerHistory/"
      id-field="oeEnrollerId"
      title-field="Enroller"
      color="green"
      :columns="historyColumns"
      :item="historyItem"
      @hide="historyItem = null"
    />
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'EnrollerTab',

    components: {
      EnrollerEdit: () => import('./EnrollerEdit'),
    },

    props: {
      openEnrollment: {
        type: Object,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      formErrors: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      gridHeaders: [
        {
          text: 'Name',
          value: 'fullName',
        },
        {
          text: 'Carrier',
          value: 'carrier',
        },
        {
          text: 'Writing #',
          value: 'writingNumber',
        },
      ],

      historyColumns: [
        {
          text: 'Name',
          value: 'fullName',
        },
        {
          text: 'Carrier',
          value: 'carrier',
        },
        {
          text: 'Writing #',
          value: 'writingNumber',
        },
      ],

      actions: [
        {
          color: 'info',
          icon: 'mdi-information-variant',
          action: 'history',
        },
      ],

      enrollerResource: new TroodyApi('oeEnroller/'),

      historyItem: null,
    }),

    methods: {
      getEnroller () {
        return this.enrollerResource.query({ openEnrollmentId: this.openEnrollment.id })
      },

      handleAction (action, data) {
        if (action === 'history') {
          this.historyItem = data
        }
      },

      itemChanged (data) {
        this.$emit('item:changed', data)
        this.$refs.resourceGrid.refresh()
      },

      prepareSave (payload) {
        if (payload) {
          payload.openEnrollmentId = this.openEnrollment.id
        }
        return payload
      },
    },
  }
</script>
